import React, {Suspense, lazy, memo, useEffect, useState} from 'react'
import cx from 'classnames'

/* Cosmos */
import Carousel from '@cosmos/carousel'

/* Utils */
import DataSet from '../../../../utils/DataSet'
import {formatPrice} from '../../../../modules/product/productDesktopUtils'
import {yieldToMain} from '../../../../utils/performance'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'

/* Actions */
import {actionCreators as productActionsCreators} from '../../../../redux/actions/productActions'

/* Components */
import VasSkeleton from './VasSkeleton'

/* Lazy Components */
const VasDescriptionModal = lazy(() => import('./modal/VasDescriptionModal'))

/* Styles */
import s from './vas.scss'

const Vas = memo(({
  dispatch,
  sku,
  merchantId,
  merchantName,
  listingId,
  productId,
  categories,
  definationName,
  vas,
  selectedVasProduct,
  categoryId,
  categoryName,
  price,
  brandName,
  productStatus,
  shippingType,
  name,
  vasLoading,
  className,
  pageTypeForDavinci
}) => {
  const [detailContentModal, setDetailContentModal] = useState(false)
  const [detailContent, setDetailContent] = useState(null)

  useEffect(() => {
    getVas()
    dispatch(
      productActionsCreators.setRemoveVasProduct.trigger()
    )
  }, [sku, merchantId])

  const getVas = () => {
    dispatch(
      productActionsCreators.getVas.trigger({
        definationName,
        merchantName,
        price,
        rootCategories: categories.map(item => parseInt(item.categoryId)),
        sku
      })
    )
  }

  const selectVasProduct = async(item, index) => {
    if (selectedVasProduct?.sku === item.suggestedSku) {
      removeVasProduct(item)
      return
    }

    await yieldToMain()
    dispatch(
      productActionsCreators.setAddVasProduct.trigger(item.suggestedSku, {
        sku: item.suggestedSku,
        listingId: item.listingId,
        quantity: 1,
        vasTypeId: item.vasTypeId,
        staticPage: item?.staticPage || ''
      })
    )
    vasServiceAddedEvent('Ekle', item)
  }

  const removeVasProduct = (item) => {
    dispatch(
      productActionsCreators.setRemoveVasProduct.trigger()
    )
    vasServiceAddedEvent('Kaldır', item)
  }

  const handleDetailButton = (event, item) => {
    event.stopPropagation();
    setDetailContent(item);
    setDetailContentModal(true)
  }

  const vasProductInformation = (item) => {
    return {
      vas_name: item?.title,
      vas_sku: item?.suggestedSku,
      vas_type: item?.vasTypeId,
      vas_brand: item?.brand,
      vas_price: item?.price || '',
      vasTypeId: item?.vasTypeId,
      staticPage: item?.staticPage
    }
  }

  const vasServiceAddedEvent = (text, item) => {
    let data = {
      category_hierarchy: categories?.map?.(item => ({
        id: item?.categoryId || '',
        name: item?.categoryName || ''
      })),
      merchant: {
        id: merchantId || '',
        name: merchantName || ''
      },
      category: {
        id: categoryId || '',
        name: categoryName || ''
      },
      product: [{
        product_id: productId || '',
        listingId: listingId || '',
        merchant: merchantName || '',
        name: name || '',
        url: window.utagData.page_url || '',
        price: price?.toString?.() || '',
        sku: sku || '',
        brand: brandName || '',
        product_status: productStatus || '',
        shipping_type: shippingType || '',
        position: '1',
      }],
      site_type: 'desktop',
      placement: 'button',
      vas_product: vasProductInformation(item),
      page_type: pageTypeForDavinci,
      page_value: sku,
      service: 'HB',
      event_type: 'Click',
      text,
    };
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.VAS_SERVICE_ADDED, data);
  }

  const carouselProps = {
    nextArrowClassname: s.nextArrow,
    prevArrowClassname: s.prevArrow,
  };

  const divProps = {
    className: s.vasContainer
  };

  if (vasLoading) {
    return <VasSkeleton className={className}/>
  }

  if (!vas?.suggestedProducts?.length && !vasLoading) {
    return <div/>
  }

  const WrapperComponent = vas?.suggestedProducts?.length > 2 ? Carousel : 'div';
  const WrapperComponentProps = vas?.suggestedProducts?.length > 2 ? carouselProps : divProps;
  return (
    <>
      <div
        className={cx(s.root, className)} data-test-id={'vas'} data-hbus={
          DataSet.createComponentViewDataForDavinci({
            placement: 'VAS',
            component: 'VAS',
            componentDetail: 'Ek hizmet ister misin?',
            pageType: 'product detail',
            pageValue: sku,
            productId: productId,
            merchantName: merchantName,
            merchantId: merchantId,
            listingId: listingId || '',
            price: price?.toString() || '',
            categoryHierarchy: `${categoryId} - ${categoryName}`,
            component_order: ''
          })
        }>
        <div>
          <div className={s.vasTitle}>Ek hizmet ister misin?</div>
          {vas?.suggestedProducts?.length > 0 &&
            <WrapperComponent {...WrapperComponentProps}>
              {
                vas?.suggestedProducts?.map((item, index) => {
                  return (
                    <button
                      className={cx(s.vasWrapper, selectedVasProduct?.sku === item.suggestedSku && s.vasSelected)}
                      onClick={() => selectVasProduct(item, index)}
                      role='checkbox'
                      aria-checked={selectedVasProduct?.sku === item.suggestedSku}
                      aria-label={`${selectedVasProduct?.sku === item.suggestedSku ? 'Seçili Ek Hizmet:':''} ${item?.title} - ${formatPrice(item?.price)}`}>
                      <div className={cx(s.vasCheckbox)} aria-hidden/>
                      <div className={s.vasContentContainer}>
                        <div className={s.vasContentTitle}>{item?.title}</div>
                        <div className={s.vasImage} aria-hidden>
                          <img src={item?.logo} alt={item?.title}/>
                        </div>
                        <div className={s.vasContent}>
                          {item?.subTitle}
                        </div>
                        <button className={s.vasButton} onClick={(e) => handleDetailButton(e, item)}>
                          {'Detayları incele'}
                          <div className={s.angleRightIcon}></div>
                        </button>
                      </div>

                      <div className={s.priceContainer}>
                        <div className={s.price}>{formatPrice(item?.price)}</div>
                        {/* <div className={s.priceOld}>9999,99 TL</div> */}
                      </div>
                    </button>
                  )
                })
              }
            </WrapperComponent>
          }
        </div>
      </div>
      {
        process.env.BROWSER &&
        detailContentModal &&
        <Suspense fallback={<div/>}>
          <VasDescriptionModal
            selectedVasProduct={selectedVasProduct}
            content={detailContent}
            logo={detailContent?.logo}
            steps={detailContent?.items_mobile}
            closeButton={setDetailContentModal}/>
        </Suspense>
      }
    </>
  )
})

export default Vas
